const AuditLogActions: {[key: string]: string} = Object.freeze({
  create: 'Create',
  update: 'Update',
  delete: 'Delete',
  upsert: 'Upsert',
  send_to_worker: 'Send to Worker',
  sync_to_channel: 'Sync to Channel',
  authenticate: 'Authenticate',
  deauthenticate: 'Deauthenticate',
  other: 'Other',
})

const AuditLogTargetTypes: {[key: string]: string} = Object.freeze({
  blackout: 'Blackout',
  channel_account: 'Channel Account',
  channel_default_rate: 'Channel Default Rate',
  channel_facility: 'Channel Facility',
  default_rate: 'Default Rate',
  event_tier: 'Event Tier',
  facility_address_alias: 'Facility Address Alias',
  inventory: 'Inventory',
  location: 'Location',
  location_solution: 'Location Solution',
  organization: 'Organization',
  parent_spot_rate: 'Parent Spot Rate',
  partner_info: 'Partner API Key',
  product: 'Product',
  // rate_management // why is this in the Postgres enum?
  reporting: 'Reporting',
  spot_rate: 'Spot Rate',
  tax_fee: 'Tax & Fee',
  // universal_inventory // why is this in the Postgres enum?
  user: 'User',
  venue_location_product: 'Venue Location Product',
  venue_tier: 'Venue Tier',
})

const ParcsCompanies: {[key: string]: string} = Object.freeze({
  avpmi: 'AVPMi',
  flash: 'Flash',
  amano: 'Amano',
  cvps: 'CVPS',
  parkonect: 'Parkonect',
  vendpark: 'Vend Park',
  skidata: 'SkiData',
  tiba: 'TIBA',
  wps: 'WPS',
  designa: 'Designa',
  t2: 'T2',
  prrs: 'PRRS',
  netpark: 'netPark',
})

const ReadWritePermissions: {[key: string]: string} = Object.freeze({
  none: 'None',
  read: 'Read',
  write: 'Write',
})

const Solutions: {[key: string]: string} = Object.freeze({
  universalInventory: 'Universal Inventory',
  rateManagement: 'Rate Management',
  blackouts: 'Blackouts',
  reporting: 'Reporting',
  // rateParity: 'Rate Parity',
  // maxCapacity: 'Max Capacity',
  terminal: 'Terminal',
  uri: 'URI',
})

const SpotHeroIQPolicyTypes: {[key: string]: string} = Object.freeze({
  ceiling: 'Ceiling',
  floor: 'Floor',
})

const TaxesFeesMetrics: {[key: string]: string} = Object.freeze({
  percent: '%',
  money: '$',
})

const TaxesFeesPrePost: {[key: string]: string} = Object.freeze({
  pre: 'Pre-Tax',
  post: 'Post-Tax',
})

const TaxesFeesTypes: {[key: string]: string} = Object.freeze({
  fixed: 'Fixed',
  per_day: 'Per Day',
})

const TransactionStatuses: {[key: string]: string} = Object.freeze({
  valid: 'Valid',
  cancelled: 'Cancelled',
})

const UserRoles: {[key: string]: string} = Object.freeze({
  super_admin: 'Super Admin',
  admin: 'Admin',
  user: 'User',
})

const Weekdays: {[key: string]: string} = Object.freeze({
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
})

export {
  AuditLogActions,
  AuditLogTargetTypes,
  ParcsCompanies,
  ReadWritePermissions,
  Solutions,
  SpotHeroIQPolicyTypes,
  TaxesFeesMetrics,
  TaxesFeesPrePost,
  TaxesFeesTypes,
  TransactionStatuses,
  UserRoles,
  Weekdays,
}
